import { getMarketsMarketIdRegions } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const MARKET_REGION_LIST = "MARKET_REGION_LIST";

export const getMarketRegionListQueryKey = (
	marketId?: number | null,
	isDeleted?: boolean,
) => {
	return [MARKET_REGION_LIST, marketId, isDeleted];
};

export function useMarketRegionList(
	marketId?: number | null,
	isDeleted?: boolean,
) {
	return useQuery({
		queryKey: getMarketRegionListQueryKey(marketId, isDeleted),
		queryFn: processResponse(() =>
			getMarketsMarketIdRegions(marketId!, isDeleted),
		),
		retry: false,
		enabled: !!marketId,
	});
}
